// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorNotification_container__3-88k","notification":"ErrorNotification_notification__2TQ7a"};